<template>
  <div class="curentScore-gauge">
    <div class="curentScore-container">
      <div
        class="curentScore-progress"
        :style="`width: ${currentScore}%; background-color: ${currentScore >= 80 ? '#f88' : '#aaa'}`"
      ></div>
      <div
        class="curentScore"
        :style="`${currentScore === null ? `color: #bbb`: ``}`"
      >{{`${currentScore !== null ? Math.ceil(currentScore) + '点' : '未採点'}`}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currentScore"]
};
</script>

<style lang="scss" scoped>
.curentScore-gauge {
  transition: all 0.3s ease;
  width: 220px;
  /* background-color: #fafafa; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 4px;
  align-items: center;
  position: relative;
  .curentScore {
    width: 100%;
    font-size: 1rem;
  }
}
.curentScore-container {
  width: 100%;
  height: 4px;
  background-color: #eee;
  .curentScore-progress {
    transition: all 0.7s ease;
    height: 100%;
    /* background-color: #f88; */
  }
}
</style>
